import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FlyoutContainer from 'components/consumer/FlyoutContainer';
import MaterialThumbnail from 'components/consumer/MaterialThumbnail';
import FabricAdditionalAttributes from 'components/consumer/FabricAdditionalAttributes';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import IconVelvet from 'components/icons/iconVelvet';
import RatioContainer from 'components/consumer/RatioContainer';
import useKeyboardControlForTabs from 'hooks/useKeyboardControlForTabs';
import useFabricReviews from 'data-hooks/useFabricReviews';
import splitArrayIntoParts from 'commons/splitArrayIntoParts';
import useScreen from 'hooks/useScreen';
import { LEATHER_PRODUCT_OPTION_ID } from 'commons/constants';
const DEFAULT_DISABLED_MATERIAL_IDS = [];
const DEFAULT_FABRIC_FAV_PROPS = {
  data: {}
};
const DEFAULT_FLASH_SALE_OPTION_IDS = [];
const DEFAULT_MATERIALS = [];
const MaterialThumbnailGroup = t0 => {
  const $ = _c(47);
  const {
    className: t1,
    disabledMaterialIds: t2,
    enableFlyout: t3,
    fabricFavProps: t4,
    flashSaleOptionIds: t5,
    flyoutAlign: t6,
    flyoutVariant,
    isEditOrder,
    isModularBundleProduct: t7,
    materials: t8,
    moreMaterialsCount,
    onClick,
    onHover,
    onMoreMaterialsClick,
    onToggleFlyOut,
    optionId,
    selectedMaterial,
    showMoreMaterialsOnDesktop: t9,
    variant
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const disabledMaterialIds = t2 === undefined ? DEFAULT_DISABLED_MATERIAL_IDS : t2;
  const enableFlyout = t3 === undefined ? true : t3;
  const fabricFavProps = t4 === undefined ? DEFAULT_FABRIC_FAV_PROPS : t4;
  const flashSaleOptionIds = t5 === undefined ? DEFAULT_FLASH_SALE_OPTION_IDS : t5;
  const flyoutAlign = t6 === undefined ? "left" : t6;
  const isModularBundleProduct = t7 === undefined ? false : t7;
  const materials = t8 === undefined ? DEFAULT_MATERIALS : t8;
  const showMoreMaterialsOnDesktop = t9 === undefined ? false : t9;
  let t10;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {};
    $[0] = t10;
  } else {
    t10 = $[0];
  }
  const [flyOutContent, setFlyOutContent] = useState(t10);
  const [isFlyOutVisible, setIsFlyOutVisible] = useState(false);
  const containerRef = useRef(null);
  const {
    isMobile
  } = useScreen();
  const thumbnailGroupRef = useRef(null);
  useKeyboardControlForTabs(thumbnailGroupRef);
  let t11;
  bb0: {
    if (isMobile && optionId !== LEATHER_PRODUCT_OPTION_ID) {
      if (materials.length < 7) {
        let t12;
        if ($[1] !== materials) {
          t12 = splitArrayIntoParts(materials, 1);
          $[1] = materials;
          $[2] = t12;
        } else {
          t12 = $[2];
        }
        t11 = t12;
        break bb0;
      }
      let t12;
      if ($[3] !== materials) {
        t12 = splitArrayIntoParts(materials, 2);
        $[3] = materials;
        $[4] = t12;
      } else {
        t12 = $[4];
      }
      t11 = t12;
      break bb0;
    }
    let t12;
    if ($[5] !== materials) {
      t12 = [materials];
      $[5] = materials;
      $[6] = t12;
    } else {
      t12 = $[6];
    }
    t11 = t12;
  }
  const newMaterials = t11;
  const {
    data: t12
  } = useFabricReviews(flyOutContent?.materialId);
  const {
    reviews,
    rating
  } = t12;
  let t13;
  if ($[7] !== disabledMaterialIds) {
    t13 = disabledMaterialIds.reduce(_temp, {});
    $[7] = disabledMaterialIds;
    $[8] = t13;
  } else {
    t13 = $[8];
  }
  const disabledMaterialsIdMap = t13;
  const {
    data: t14
  } = fabricFavProps;
  const {
    favMaterials
  } = t14;
  let t15;
  if ($[9] !== enableFlyout || $[10] !== favMaterials || $[11] !== isEditOrder || $[12] !== isModularBundleProduct || $[13] !== materials || $[14] !== onToggleFlyOut || $[15] !== rating || $[16] !== reviews) {
    t15 = (isVisible, optionValueId) => {
      const newTop = containerRef?.current?.getBoundingClientRect().top || 0;
      const selectedValue = materials?.find(material => material?.materialId === optionValueId);
      let content = {};
      const formattedAddlCost = _temp2;
      if (isVisible && selectedValue) {
        const titleInfo = <>{isEditOrder && !!selectedValue?.origAddlCost && selectedValue.origAddlCost !== selectedValue.additionalCost && <span className="line-through">{`$${selectedValue?.origAddlCost}`}</span>}{!!selectedValue?.additionalCost && <span className={classNames("PDP_flyout_AddlCost", {
            "text-red ml-1": isEditOrder
          })}>{`${formattedAddlCost(selectedValue.additionalCost)}${isModularBundleProduct ? "/piece" : ""}`}</span>}</>;
        const favDisabledNotice = selectedValue?.materialId && !!favMaterials?.[selectedValue.materialId] && selectedValue?.applicableForProduct === false ? <span className={classNames("PDP_flyout_AddlCost", {
          "text-red ml-1": true
        })}>{`This product is not available in ${selectedValue.label.trim()}`}</span> : "";
        const title = selectedValue?.label?.trim() || "";
        content = {
          materialId: optionValueId,
          top: newTop,
          subSubTitle: selectedValue.tier || selectedValue.groupMaterialDesc || favDisabledNotice ? <><FabricAdditionalAttributes selectedItemGroupMaterial={selectedValue.groupMaterial} selectedItemGroupCleaningCode={selectedValue.cleaningCode} isPetAndKidFriendly={!!selectedValue.pet_friendly} isSustainable={!!selectedValue.sustainable_fabric} isGreenguardGold={!!selectedValue.greenguard_fabric} selectedItemTier={selectedValue.tier} showCleaningToolTip={false} isPantoneFabric={selectedValue.pantone_flag} materialComposition={selectedValue.groupMaterialDesc} />{favDisabledNotice}</> : null,
          subTitle: reviews?.length || selectedValue.velvet ? <>{reviews ? <RatingAndReviews rating={rating} numberOfReviews={reviews?.length} /> : null}{selectedValue.velvet ? <div className="items-center flex"><IconVelvet /><span className="text-[.8125rem] leading-[1.4375rem] font-bold text-[#af87a1] tracking-[.013rem] pl-0.5">Velvet</span></div> : null}</> : null,
          imageUrl: selectedValue?.image,
          content: selectedValue?.description,
          title,
          titleExtra: title && selectedValue?.exclude_from_sale ? "- Limited Edition" : "",
          titleInfo: selectedValue?.additionalCost ? titleInfo : 0,
          showFavIcon: !!(favMaterials && !selectedValue?.applicableForProduct === false && favMaterials[optionValueId])
        };
      }
      if (enableFlyout) {
        if (onToggleFlyOut) {
          onToggleFlyOut(content, isVisible);
        } else {
          setFlyOutContent(content);
          setIsFlyOutVisible(isVisible);
        }
      }
    };
    $[9] = enableFlyout;
    $[10] = favMaterials;
    $[11] = isEditOrder;
    $[12] = isModularBundleProduct;
    $[13] = materials;
    $[14] = onToggleFlyOut;
    $[15] = rating;
    $[16] = reviews;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const toggleFlyOut = t15;
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setIsFlyOutVisible(false);
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const onClose = t16;
  const t17 = `relative w-full ${className}`;
  const t18 = variant === "PDPSelectUpholsteryUI" || variant === "PDPSelectUpholsteryUI--quickview";
  const t19 = variant === "PDPSelectUpholsteryUI--quickview";
  let t20;
  if ($[19] !== t17 || $[20] !== t18 || $[21] !== t19) {
    t20 = classNames(t17, {
      "max-[1023px]:[-ms-overflow-style:none] max-[1023px]:overflow-x-scroll max-[1023px]:overflow-y-hidden max-[1023px]:pl-5 max-[1023px]:relative max-[1023px]:[scrollbar-width:none] max-[1023px]:w-screen lg:max-[1023px]:h-[45px] max-[1023px]:md:pl-[3.333vw] [&::-webkit-scrollbar]:max-[1023px]:hidden": t18,
      "max-[1023px]:md:h-auto max-[1023px]:md:overflow-auto max-[1023px]:md:!p-0 max-[1023px]:md:w-auto": t19
    });
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
    $[22] = t20;
  } else {
    t20 = $[22];
  }
  let t21;
  if ($[23] !== flashSaleOptionIds || $[24] !== flyOutContent || $[25] !== flyoutAlign || $[26] !== flyoutVariant || $[27] !== isFlyOutVisible) {
    t21 = isFlyOutVisible ? <FlyoutContainer top={flyOutContent.top} titleInfo={flyOutContent.titleInfo} subTitle={flyOutContent.subTitle} subSubTitle={flyOutContent.subSubTitle} imageUrl={flyOutContent.imageUrl} content={flyOutContent.content} title={flyOutContent.title} titleExtra={flyOutContent.titleExtra} onClose={onClose} isOpen={isFlyOutVisible} align={flyoutAlign} showFavIcon={flyOutContent.showFavIcon} isInFlashSale={flyOutContent?.materialId ? flashSaleOptionIds.includes(flyOutContent.materialId) : false} flyoutVariant={flyoutVariant} /> : null;
    $[23] = flashSaleOptionIds;
    $[24] = flyOutContent;
    $[25] = flyoutAlign;
    $[26] = flyoutVariant;
    $[27] = isFlyOutVisible;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== disabledMaterialsIdMap || $[30] !== fabricFavProps || $[31] !== favMaterials || $[32] !== flashSaleOptionIds || $[33] !== moreMaterialsCount || $[34] !== newMaterials || $[35] !== onClick || $[36] !== onHover || $[37] !== onMoreMaterialsClick || $[38] !== selectedMaterial?.materialId || $[39] !== showMoreMaterialsOnDesktop || $[40] !== toggleFlyOut || $[41] !== variant) {
    t22 = Object.keys(newMaterials)?.map(key => <div className={classNames("max-[1023px]:flex max-[1023px]:max-w-full lg:grid lg:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] lg:relative lg:z-0", {
      "max-[1023px]:md:grid max-[1023px]:md:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] max-[1023px]:md:relative max-[1023px]:md:z-0": variant === "PDPSelectUpholsteryUI--quickview"
    })} ref={thumbnailGroupRef} key={key}>{newMaterials[key]?.filter(_temp3)?.map(t23 => {
        const {
          image,
          label,
          materialId,
          upholsteryOptionId,
          description,
          color,
          applicableForProduct: t24
        } = t23;
        const applicableForProduct = t24 === undefined ? true : t24;
        const show = !(fabricFavProps?.data?.hideMaterialThumbnails && applicableForProduct);
        return <div key={materialId} className={classNames("h-full w-full max-[1023px]:flex-shrink-0 max-[1023px]:h-[59px] max-[1023px]:min-w-[59px] max-[1023px]:w-[59px]", {
          "max-[1023px]:md:h-full max-[1023px]:md:min-w-[auto] max-[1023px]:md:w-full": variant === "PDPSelectUpholsteryUI--quickview",
          hidden: !show
        })}><MaterialThumbnail color={color} description={description} fabricFavProps={fabricFavProps} image={image} isDisabled={disabledMaterialsIdMap[materialId] || !applicableForProduct} isFavMaterial={!!favMaterials?.[materialId]} isInFlashSale={flashSaleOptionIds.includes(materialId)} isSelected={materialId === selectedMaterial?.materialId} label={label} materialApplicableForProduct={applicableForProduct} materialId={materialId} onClick={onClick} onHover={onHover} toggleFlyOut={toggleFlyOut} upholsteryOptionId={upholsteryOptionId} /></div>;
      })}{!!moreMaterialsCount && !!onMoreMaterialsClick && <div className={classNames("h-full w-full max-[1023px]:flex-shrink-0 max-[1023px]:h-[59px] max-[1023px]:min-w-[59px] max-[1023px]:w-[59px] ml-1.5 md:hidden", {
        "max-[1023px]:md:h-full max-[1023px]:md:min-w-[auto] max-[1023px]:md:w-full": variant === "PDPSelectUpholsteryUI--quickview",
        "md:block": showMoreMaterialsOnDesktop
      })}><RatioContainer className="items-center flex justify-center h-full" tabIndex="0" onClick={onMoreMaterialsClick}><div className="items-center rounded-lg flex justify-center p-[5px] relative h-[calc(100%_-_4px)] hover:cursor-pointer after:[content:''] after:block after:absolute after:rounded-[inherit] before:[content:''] before:block before:absolute before:rounded-[inherit] before:z-0 before:w-full before:h-full before:[background:linear-gradient(90deg,#fdde5c_0,#f8ab5e_16.66667%,#f56a62_33.33333%,#a176c8_50%,#759beb_66.66667%,#65beb3_83.33333%,#70db96)] after:z-[1] after:w-[calc(100%_-_4px)] after:h-[calc(100%_-_4px)] after:bg-white"><span className="text-xs tracking-[.025rem] text-center z-[2] leading-[.9rem]">{`${moreMaterialsCount}+ more`}</span></div></RatioContainer></div>}<div className="flex-1 flex-shrink-0 min-w-[20px] w-5 lg:hidden" /></div>);
    $[29] = disabledMaterialsIdMap;
    $[30] = fabricFavProps;
    $[31] = favMaterials;
    $[32] = flashSaleOptionIds;
    $[33] = moreMaterialsCount;
    $[34] = newMaterials;
    $[35] = onClick;
    $[36] = onHover;
    $[37] = onMoreMaterialsClick;
    $[38] = selectedMaterial?.materialId;
    $[39] = showMoreMaterialsOnDesktop;
    $[40] = toggleFlyOut;
    $[41] = variant;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t20 || $[44] !== t21 || $[45] !== t22) {
    t23 = <div className={t20} ref={containerRef}>{t21}{t22}</div>;
    $[43] = t20;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
};
MaterialThumbnailGroup.propTypes = {
  disabledMaterialIds: PropTypes.arrayOf(PropTypes.number),
  enableFlyout: PropTypes.bool,
  flyoutAlign: PropTypes.oneOf(['left', 'right']),
  materials: PropTypes.arrayOf(PropTypes.shape(MaterialThumbnail.propTypes)),
  moreMaterialsCount: PropTypes.number,
  onClick: PropTypes.func,
  onMoreMaterialsClick: PropTypes.func,
  onToggleFlyOut: PropTypes.func,
  selectedMaterial: PropTypes.shape({
    description: PropTypes.string,
    image: PropTypes.string,
    label: PropTypes.string,
    materialId: PropTypes.number,
    upolsteryOptionId: PropTypes.number
  }),
  fabricFavProps: PropTypes.object,
  flashSaleOptionIds: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  flyoutVariant: PropTypes.oneOf(['standard', 'protectionPlan', 'materialSwatch']),
  isEditOrder: PropTypes.bool,
  isModularBundleProduct: PropTypes.bool,
  onHover: PropTypes.func,
  showMoreMaterialsOnDesktop: PropTypes.bool,
  optionId: PropTypes.number,
  variant: PropTypes.oneOf(['PDPSelectUpholsteryUI', 'PDPSelectUpholsteryUI--quickview'])
};
export default MaterialThumbnailGroup;
function _temp(acc, cur) {
  acc[cur] = true;
  return acc;
}
function _temp2(cost) {
  return cost < 0 ? `-$${cost * -1}` : `+$${cost}`;
}
function _temp3(material_0) {
  return material_0?.materialId != null;
}